import { Component, OnInit } from '@angular/core';
import { User, Employee } from '../../models';
import { EmsEmployeeService } from '../../services/ems';
import { ToastyService } from 'ng2-toasty';
import { AmsEmployeeService } from '../../services/ams';
import { Router, ActivatedRoute } from '@angular/router';
import { ValidatorService, EmsOrganizationService, EmsAuthService } from '../../services';
import { EmsEmployee } from '../../models/ems/employee';
import { Organization } from '../../models/organization';
import { LocalStorageService } from '../../services/local-storage.service';
import { Subscription } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { Message } from '../../models/send-it/message';
import { SentItMessageService } from '../../services/send-it/sent-it-message.service';
import { EmailValidator } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'aqua-demo-form',
  templateUrl: './demo-form.component.html',
  styleUrls: ['./demo-form.component.css']
})
export class DemoFormComponent implements OnInit {

  name: string;

  email: string;

  phone: string;

  organization: string;

  employees: string;

  message: Message;

  token = 'google-captcha-token'; //todo

  constructor(
    private sentItMessageService: SentItMessageService,
    public validatorService: ValidatorService,
    private emsAuthService: EmsAuthService
  ) {
  }


  ngOnInit() {
  }

  correctCaptcha = (response) => {
    console.log('google captcha response', response);
    this.token = response;
  }

  getMessageModel() {
    const messageModel = {
      to: [{
        email: 'amit96amitsharma@gmail.com' //todo user_code
      }, {
        email: 'info@mindfulsas.com'
      }],
      from: {
        email: this.email
      },
      template: {
        code: 'aqua-demo-request'
      },
      data: {
        email: this.email,
        phone: this.phone,
        name: this.name,
        organization: this.organization,
        employees: this.employees
      },
      modes: ['email'],
      options: { isHidden: true }
    }
    return messageModel
  }

  submit() {
    const messageModel = this.getMessageModel();
      this.sentItMessageService.send(this.token, messageModel)
      .subscribe((serverResponse) => {
        this.message = serverResponse;
        alert('Our Technical Team Will Shortly Connection')
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = 'http://www.aquateams.com'
        // a.target = '_blank';
        a.setAttribute('style', 'display: none');
        a.download = 'test';
        a.click();
        document.body.removeChild(a);

      })
  }

}




// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/demo-form/demo-form.component.ts